import Vue from 'vue'
import {
  Button,
  TabPane,
  Tabs,
  Switch,
  Upload,
  Dialog,
  MessageBox,
  Message,
  Input,
  DatePicker,
  Tooltip,
  Table,
  TableColumn,
  Tag,
  Select,
  Option,
  Pagination,
  Loading,
  Form,
  FormItem,
  Checkbox,
  CheckboxGroup,
} from 'element-ui';
// import lang from 'element-ui/lib/locale/lang/en'
import lang from 'element-ui/lib/locale/lang/ja'
import locale from 'element-ui/lib/locale'

// 设置语言
locale.use(lang)

Vue.use(Button)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Switch)
Vue.use(Upload)
Vue.use(Dialog)
Vue.use(Input)
Vue.use(DatePicker)
Vue.use(Tooltip)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Tag)
Vue.use(Select)
Vue.use(Option)
Vue.use(Pagination)
Vue.use(Loading.directive)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)

Vue.prototype.$msgbox = MessageBox
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$message = Message
Vue.prototype.$loading = Loading.service